import React, { useState, useContext } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './style.module.css';
import { CircularProgress } from '@mui/material';
import MobileContext from 'context/MobileContext';
import Button from '../Button';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import Paper from '@material-ui/core/Paper';
import {
  emailIcon,
  orangeCalendarIcon,
} from 'assets/icons';
import { leftArrowCalendar, rightArrowCalendar } from 'assets/newIcons';

const DateRangePickerMonth = ({
  search,
  searchButtonLabel,
  isStatement,
  secondaryAction,
  open,
  setOpen,
  loading,
  setloading,
}) => {
  const currentDate = new Date();
  const [selectedMonth, setSelectedMonth] = useState(currentDate);
  const isMobile = useContext(MobileContext);
  return (
    <div className={styles.container}>
      <div className={styles.input} onClick={() => setOpen(!open)}>
        <p className={styles.yearHeading}>
          <span style={{ fontFamily: 'Montserrat' }}>Year: </span>
          {selectedMonth.getFullYear()}
        </p>
        <img
          style={{ width: isMobile ? 20 : 25, height: isMobile ? 20 : 25 }}
          src={orangeCalendarIcon}
          alt=""
        />
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={styles.modal}
        open={open}
        onClose={() => setOpen(false)}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <Paper elevation={0} className={styles.paper}>
            <div>
              <DatePicker
                renderCustomHeader={({ date, decreaseYear, increaseYear }) => (
                  <div className={styles.headerAction}>
                    <div className={styles.popupYearHeading}>
                      <p>{date.getFullYear()}</p>
                    </div>
                    <div className={styles.arrowWrapper}>
                      <img
                        className={styles.leftArrow}
                        src={leftArrowCalendar}
                        alt=""
                        onClick={decreaseYear}
                      />
                      <img
                        className={styles.rightArrow}
                        src={rightArrowCalendar}
                        alt=""
                        onClick={increaseYear}
                      />
                    </div>
                  </div>
                )}
                selected={selectedMonth}
                onChange={date => setSelectedMonth(date)}
                dateFormat="MMMM"
                inline
                showMonthYearPicker
                maxDate={new Date()}
              />
              <div className={styles.button}>
                {search && (
                  <Button
                    onClick={() => {
                      search(selectedMonth);
                      setOpen(false);
                    }}
                    className={styles.buttonEl}
                  >
                    {searchButtonLabel}
                  </Button>
                )}
                {isStatement && (
                  <div className={styles.buttonDiv}>
                    {loading ? (
                      <CircularProgress size={30} style={{ color: '#fe5000' }} />
                    ) : (
                      <img
                        alt=""
                        width={isMobile ? 22 : 32}
                        height={isMobile ? 22 : 32}
                        src={emailIcon}
                      />
                    )}
                    <div
                      styleType="tertiary"
                      onClick={() => {
                        secondaryAction(selectedMonth);
                        setloading(true);
                      }}
                      className={styles.statementButton}
                    >
                      Email PDF
                    </div>
                  </div>
                )}
              </div>
            </div>
          </Paper>
        </Fade>
      </Modal>
    </div>
  );
};

export default DateRangePickerMonth;
